import { useParams } from '@tanstack/react-router';
import { SchemaFormFields } from '@mews-commander/form';
import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { hasPlatformScopeWithAccessAllEnterprises } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { useCommanderSelector } from '@mews-commander/utils';
import { IntegrationSettingsUpdateLayout, IntegrationUpdateForm } from '../common';
import { IntegrationUpdateFormLayout } from '../common/components/layout';
import { getUpdateFormDefinition } from './formDefinition';
import { schema, updateSchema } from './schema';
import { useDeleteHandler, useUpdateHandler } from './mutations';
import { useInitialValuesForEdit } from './hooks';

export const MewsBIIntegrationUpdateForm = () => {
    const canAccessAllEnterprises = useCommanderSelector(hasPlatformScopeWithAccessAllEnterprises);
    const localizeText = useLocalizeText();

    const { id } = useParams({ from: '/_authenticated/$currentEnterpriseId/EnterpriseIntegration/$id/Update' });
    const initialValues = useInitialValuesForEdit(id);
    const formDefinition = getUpdateFormDefinition(canAccessAllEnterprises, initialValues.enterpriseIds);

    const { handleSubmit, isPending: updateHandlerIsPending } = useUpdateHandler(id);
    const { handleDelete, isPending: deleteHandlerIsPending } = useDeleteHandler(id);

    const isLoading = updateHandlerIsPending || deleteHandlerIsPending;

    return (
        <IntegrationSettingsUpdateLayout
            entityName={localizeText({ textKey: TextKey.MewsBI })}
            deleteAction={handleDelete}
        >
            <Stack spacing="500" vertical>
                <IntegrationUpdateForm
                    defaultValues={initialValues}
                    handleSubmit={handleSubmit}
                    isLoading={isLoading}
                    schema={updateSchema}
                >
                    <IntegrationUpdateFormLayout hideEnableIntegration hideEnableBanner>
                        <SchemaFormFields schema={schema} formDefinition={formDefinition} />
                    </IntegrationUpdateFormLayout>
                </IntegrationUpdateForm>
            </Stack>
        </IntegrationSettingsUpdateLayout>
    );
};
